import CreateSuccessStoryContainer from "../containers/CreateSuccessStoryContainer";

const CreateSuccessStoryPage = () => {
  return (
    <CreateSuccessStoryContainer />
  );
};

export default CreateSuccessStoryPage;
